var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.125 9.0625H16.875",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 5.9375H16.875",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 2.8125H16.875",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.1875H12.5C12.5 12.8505 12.2366 13.4864 11.7678 13.9553C11.2989 14.4241 10.663 14.6875 10 14.6875C9.33696 14.6875 8.70107 14.4241 8.23223 13.9553C7.76339 13.4864 7.5 12.8505 7.5 12.1875H1.25C1.08424 12.1875 0.925269 12.2533 0.808058 12.3706C0.690848 12.4878 0.625 12.6467 0.625 12.8125V15.9375C0.625 16.269 0.756696 16.587 0.991117 16.8214C1.22554 17.0558 1.54348 17.1875 1.875 17.1875H18.125C18.4565 17.1875 18.7745 17.0558 19.0089 16.8214C19.2433 16.587 19.375 16.269 19.375 15.9375V12.8125C19.375 12.6467 19.3092 12.4878 19.1919 12.3706C19.0747 12.2533 18.9158 12.1875 18.75 12.1875Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveFolder);
export default __webpack_public_path__ + "static/media/archive-folder.669a328bc129bfb02abae29a96813f26.svg";
export { ForwardRef as ReactComponent };